export default {
  jp: {
    title: {
      list: 'グループ分類一覧',
      add: 'グループ分類登録',
      detail: 'グループ分類詳細／変更',
      delete: 'グループ分類削除'
    },
    label: {
      groupLarge: '大分類',
      groupSmall: '小分類',
      companyLabel: '会社ラベル',
      branchLabel: '支社ラベル',
      displayOrder: '表示順',
      accountEntryDisplayFlg: '申請時非表示設定',
      accountEntryAddCompanyFlg: '申請時会社追加許可',
      adminUpdFlg: '管理者更新設定'
    },
    ph: {
      groupSmallNameJp: '小分類（日本語）を入力してください',
      groupSmallNameEn: '小分類（英語）を入力してください',
      companyLabelJp: '会社ラベル（日本語）を入力してください',
      companyLabelEn: '会社ラベル（英語）を入力してください',
      branchLabelJp: '支社ラベル（日本語）を入力してください',
      branchLabelEn: '支社ラベル（英語）を入力してください',
      displayOrder: '表示順を入力してください',
      accountEntryDisplayFlg: 'アカウント申請時に表示を行わない',
      accountEntryAddCompanyFlg: 'アカウント申請時に会社の追加ができる',
      adminUpdFlg: '管理者により小分類を変更可能とする'
    },
    headers: {
      groupLargeName: 'グループ大分類',
      groupSmallName: 'グループ小分類',
      displayOrder: '表示順'
    },
    error: {
      groupSmallId: {
        notExist: '既に削除済みのグループです。一覧に戻り、最新の情報を確認してください。'
      },
      groupLargeId: {
        required: 'グループ大分類は入力必須項目です。',
        invalid: 'グループ大分類の入力内容に不備があります。'
      },
      groupSmallNameJp: {
        required: '小分類（日本語）は入力必須項目です。',
        maxLength: '小分類（日本語）は50文字以内で入力してください。'
      },
      companyLabelJp: {
        maxLength: '会社ラベル（日本語）は50文字以内で入力してください。'
      },
      companyLabelEn: {
        maxLength: '会社ラベル（英語）は50文字以内で入力してください。'
      },
      branchLabelJp: {
        maxLength: '支社ラベル（日本語）は50文字以内で入力してください。'
      },
      branchLabelEn: {
        maxLength: '支社ラベル（英語）は50文字以内で入力してください。'
      },
      groupSmallNameEn: {
        required: '小分類（英語）は入力必須項目です。',
        maxLength: '小分類（英語）は50文字以内で入力してください。'
      },
      displayOrder: {
        required: '表示順は入力必須項目です。',
        minNumber: '表示順は0以上の数値で入力してください。'
      },
      groupSmallDelete: {
        used: 'このグループを利用中のアカウントが存在するため、削除を行うことができません。'
      }
    },
    button: {
      back: '戻る',
      toAdd: 'グループ追加',
      add: '登録する',
      modify: '変更する',
      delete: 'グループを削除する'
    },
    desc: {
      list: {
        text1: 'グループ小分類の名称をクリックすることで編集画面を表示します。'
      },
      delete: {
        text1: 'グループ分類を削除する場合は、以下のボタンをクリックしてください。'
      }
    }
  },
  en: {
  }

}
